module.exports = __webpack_public_path__ + "img/628.9e313de7.png";